import styles from "./index.css";
import PropTypes from "prop-types";
import { withTranslation } from "../../translation";
import classnames from "classnames";

const ProductSponsored = ({ formatTranslation, className }) => (
  <div className={classnames(styles.productSponsored, className)}>
    {formatTranslation("sponsored_product_ads")}
  </div>
);

ProductSponsored.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default withTranslation(ProductSponsored);
